// 俱乐部页面
export default [
  // 我的俱乐部
  {
    path: '/MySociety',
    name: 'MySociety',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "MySociety" */ '@/components/society/my-society.vue')
  },
  // 俱乐部首页
  {
    path: '/SocietyIndex',
    name: 'SocietyIndex',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "SocietyIndex" */ '@/components/society/society-index.vue')
  },
  // 组织首页
  {
    path: '/OrganizeIndex',
    name: 'OrganizeIndex',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "OrganizeIndex" */ '@/components/society/organize-index.vue')
  },
  // 编辑报告
  {
    path: '/SocietyEditReport',
    name: 'SocietyEditReport',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "SocietyEditReport" */ '@/components/society/edit-report.vue')
  },
  // 俱乐部报告
  {
    path: '/SocietiesReport',
    name: 'SocietiesReport',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "SocietiesReport" */ '@/components/society/societies-report.vue')
  },
  // 俱乐部报告详情
  {
    path: '/SocietiesReportDetails',
    name: 'SocietiesReportDetails',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "SocietiesReportDetails" */ '@/components/society/report-details.vue')
  },
  // 报告内容
  {
    path: '/SocietyReportContent',
    name: 'SocietyReportContent',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "SocietyReportContent" */ '@/components/society/report-content.vue')
  },
  {
    path: '/AllAssociation',
    name: 'AllAssociation',
    meta: {
      IndexHeader: true,
      itemIndex: 0
    },
    component: () =>
      import(/* webpackChunkName: "SocietyReportContent" */ '@/components/society/allAssociation.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/society.js